module.exports = __webpack_public_path__ + "static/media/mediservice.314128d9.jpg";